import {LocalStorageKeys} from "../utils/constants";

export const getSessionData = (key=null) => {
  let sd = window.localStorage.getItem(LocalStorageKeys.SessionData);
  if (!sd){
    return null;
  }
  sd = JSON.parse(sd);
  return sd.hasOwnProperty(key) ? sd[key] : null;
}
export const setSessionData = (key, value) => {
  let sd = getSessionData();
  if (!sd){
    sd = {};
  }
  sd[key] = value;
  window.localStorage.setItem(LocalStorageKeys.SessionData, JSON.stringify(sd));
};

export const clearSessionData = () => {
  window.localStorage.removeItem(LocalStorageKeys.SessionData);
};